import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  min-width: 1100px;
  margin: 0 auto;
`;

export default Container;



// WEBPACK FOOTER //
// ./src/components/Atoms/Container/index.js